import { avalibeRouter } from '~/stores/avalibeRouter';
import api from '~/api/api.ts';
export default defineNuxtPlugin(async nuxtContext => {
    const routeStore = avalibeRouter();
    const routeList = await api.getPagesApp(nuxtContext.$i18n.locale.value);
    const avalibleRoutes = routeList === null ? [] : routeList;
    routeStore.setRoutes(avalibleRoutes);
});
